import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import PersonSharpIcon from "@mui/icons-material/PersonSharp";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { Button } from "@mui/material";
import BsQuestionOctagon from "../../assets/images/BsQuestionOctagon.svg"
import "./Header.css";
import questionMarkIcon from "../../assets/images/question-octagon.svg";
import bellIcon from "../../assets/images/bell-icon.svg";
import Tooltip from "../../components/uikit/components/Tooltip/Tooltip";
import Fade from "@mui/material/Fade";
import { useCookies } from "react-cookie";
import { getUserDataStart } from "../../features/currentUser/currentUserSlice";
import LogOutModal from "../../components/uikit/components/modals/LogOutModal/LogOutModal";
import { ROUTES } from "../../constants/constant";

const HeaderComp = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [userInformation, setUserInformation] = useState(null);
  const { user } = useSelector((state) => state);
  const [cookies, setCookie, removeCookie] = useCookies(["inizionavigator"]);
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const userInfo = useSelector((state) => state?.user?.userInfo ?? "");

  useEffect(() => {
    const fetchData = async () => {
      try {
        dispatch(getUserDataStart());
        const userData = await userInfo();
        setUserInformation(userData?.data);
        sessionStorage.setItem("userInfo", JSON.stringify(userData.data));
      } catch (error) {
        // console.error("Error fetching user information:", error);
      }
    };
    fetchData();
  }, []);

  const handleLogoutWithConfirmation = async () => {
    let isHavingLockedProjects = true;

    // dispatch(openLoader());
    // try {
    //   const responseData = await listLockedProjects(userInfo.email, userInfo.id);
    //   const projects = responseData?.data ?? [];
    //   if (projects.length === 0) isHavingLockedProjects = false;
    // } catch (error) {}
    // dispatch(closeLoader());

    if (isHavingLockedProjects) {
      setShowLogoutModal(true);
    } else {
      await handleLogout();
    }
  };

  const handleLogout = async () => {
    setShowLogoutModal(false);
    sessionStorage.clear();
    localStorage.clear();
    // Cookies.remove("csrftoken");
    // Cookies.remove("sessionid");
    // Cookies.remove("access-token");
    // navigate("/login");
    removeCookie(`inizionavigator`, {
      path: "/",
      domain: process.env.REACT_APP_COOKIE_DOMAIN,
    });
    window.location.href = process.env.REACT_APP_LOGIN_URL;
  };

  async function handleLogoutAndCloseProjectAnyway() {
    await handleLogout();
  }

  async function handleLogoutAndUnlockProject() {
    // dispatch(openLoader());
    try {
      // await unlockAllProject(userInfo.email, userInfo.id);
      // dispatch(closeLoader());

      // await handleLogout();
      navigate(ROUTES.HOME_PAGE);
      setShowLogoutModal(false);
    } catch (error) {
      // dispatch(openSnackbar({ message: "Unable to unlock all projects", type: SNACKBAR_TYPES.ERROR }));
    }
    // dispatch(closeLoader());
  }
  const SSOHomePageHandler = () => {
    let url = process.env.REACT_APP_LOGIN_URL;
    console.log("first : ", url);
    let lastIndex = url.lastIndexOf("login");
    if (lastIndex !== -1) {
      url = url.substring(0, lastIndex) + url.substring(lastIndex + "login".length);
    }
    console.log("second : ", url);
    window.location.href = url;
    
  }

  return (
    <div className="container-fluid header-container">
      <nav className="d-flex  justify-content-between align-items-center mx-auto pt-[10px]" style={{ paddingTop: "10px" }}>
        <div className="d-flex align-items-center"  style={{ cursor: "pointer" }} 
         onClick={() => navigate("/")}>
          <div className="d-flex align-items-end justify-content-center flex-column">
            <div className="logoTextSize d-flex">
              <span className="logoText">Clarity</span> <span className="text-green logoBold">NAV</span>
            </div>
            <span className="mb-[9px] logo d-flex w-100 justify-content-end align-items-end">inizioNavigator.ai</span>
          </div>
        </div>

        <div className="right_nav d-flex align-items-center justify-content-center gap-30">
          <div className="d-flex align-items-center justify-content-center">
            <div className="d-flex align-items-center justify-content-center">
              <div className="d-flex align-items-center gap-30 mr-30">
                 <div><svg onClick={SSOHomePageHandler} stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" className="voc-home-icon" height="25px" width="25px" xmlns="http://www.w3.org/2000/svg"><path d="M11.03 2.59a1.501 1.501 0 0 1 1.94 0l7.5 6.363a1.5 1.5 0 0 1 .53 1.144V19.5a1.5 1.5 0 0 1-1.5 1.5h-5.75a.75.75 0 0 1-.75-.75V14h-2v6.25a.75.75 0 0 1-.75.75H4.5A1.5 1.5 0 0 1 3 19.5v-9.403c0-.44.194-.859.53-1.144ZM12 3.734l-7.5 6.363V19.5h5v-6.25a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 .75.75v6.25h5v-9.403Z"></path></svg></div>
                 <Tooltip title="Help">
                    <img className="header-tooltip" src={questionMarkIcon} alt="" />
                </Tooltip>
                <Tooltip title="Notification">
                    <img className="header-tooltip" src={bellIcon} alt="" />
                </Tooltip>
              </div>
              <Tooltip TransitionComponent={Fade} TransitionProps={{ timeout: 400 }} title="User Profile">
                <span className="AvatarIconStyle">
                  <PersonSharpIcon />
                </span>
              </Tooltip>
              <div className="d-flex flex-column mx-2">
                <p className="d-flex align-items-start fs-14 mb-0 userName">{user?.userInfo?.name}</p>
                <p className="d-flex align-items-center fs-11 mb-0 userIdInfo">{user?.userInfo?.email}</p>
              </div>
            </div>
          </div>
          <Button variant="contained" className="iconButtonStyle" size="medium" color="secondary" onClick={() => handleLogoutWithConfirmation()}>
            <Tooltip TransitionComponent={Fade} TransitionProps={{ timeout: 400 }} title="Logout">
              <ExitToAppIcon className="logoutIconStyle" />
            </Tooltip>
          </Button>
        </div>
      </nav>
      <LogOutModal
        open={showLogoutModal}
        handleOnClose={() => {
          setShowLogoutModal(false);
        }}
        onCloseProjectAnyway={() => handleLogoutAndCloseProjectAnyway()}
        onUnlockProject={() => handleLogoutAndUnlockProject()}
      />
    </div>
  );
};

export default HeaderComp;
